import { gql } from '@apollo/client';

export const GET_DESIGNER_STEP_STATUS = gql`
  query GetDesignerStepStatus($designerId: String!) {
    getDesignerStepStatus(designerId: $designerId) {
      currentStep
      completedSteps
      nextStep
      profileExists
      profile {
        _id
        designerId
        personalityType
        stepCompletion {
          personalityCompleted
          expertiseCompleted
          styleCompleted
          workStyleCompleted
          preferencesCompleted
        }
        expertise {
          projectTypes
          projectRankings {
            category
            ranking
          }
          experience
          experienceRankings {
            experience
            ranking
          }
          competency {
            accessibility
            petFriendly
            smartHome
            customStorage
            specificAcoustic
            evironmentallySustainable
            uniqueLightingEffects
            historicalPreservation
            outdoorLiving
            specializedVentilation
            fengShui
            artIntegration
            wineCellar
            homeGym
            strengths {
              strength
              ranking
            }
          }
        }
        style {
          anyStyle
          knownForStyle
          strongStyles
          styleRankings {
            style
            ranking
          }
        }
        workStyle {
          partnershipOptions
          compensationModel
          presentationType
          minimumBudget
        }
        preferences {
          social {
            pronouns
            pets
            lgbtqPositive
            womenOwned
            minorityOwned
            preferToWorkWithRace
            politicalAffiliation
            otherPoliticalAffiliation
            preferSamePolitics
          }
          partnershipStyleRankings {
            partnershipStyle
            ranking
          }
          acquisitionPreferences
          acquisitionRankings {
            acquisitionPreference
            ranking
          }
          ageRange
          children
          zipCodes
        }
      }
    }
  }
`;

export const CREATE_DESIGNER_MATCHING_PROFILE = gql`
  mutation CreateDesignerMatchingProfile(
    $designerId: String!
    $personalityType: PersonalityType
    $stepCompletion: DesignerMatchingProfileStepCompletionInput
    $expertise: DesignerMatchingProfileExpertiseInput
    $style: DesignerMatchingProfileStyleInput
    $workStyle: DesignerMatchingProfileWorkStyleInput
    $preferences: DesignerMatchingProfilePreferencesInput
  ) {
    createDesignerMatchingProfile(
      designerId: $designerId
      personalityType: $personalityType
      stepCompletion: $stepCompletion
      expertise: $expertise
      style: $style
      workStyle: $workStyle
      preferences: $preferences
    )
  }
`;

export const UPDATE_DESIGNER_MATCHING_PROFILE = gql`
  mutation UpdateDesignerMatchingProfile(
    $_id: ID!
    $personalityType: PersonalityType
    $stepCompletion: DesignerMatchingProfileStepCompletionInput
    $expertise: DesignerMatchingProfileExpertiseInput
    $style: DesignerMatchingProfileStyleInput
    $workStyle: DesignerMatchingProfileWorkStyleInput
    $preferences: DesignerMatchingProfilePreferencesInput
  ) {
    updateDesignerMatchingProfile(
      _id: $_id
      personalityType: $personalityType
      stepCompletion: $stepCompletion
      expertise: $expertise
      style: $style
      workStyle: $workStyle
      preferences: $preferences
    )
  }
`;

export const GET_DESIGNER_MATCHING_PROFILE = gql`
  query GetDesignerMatchingProfile($designerId: String!) {
    getDesignerMatchingProfile(designerId: $designerId) {
      _id
      personalityType
      expertise {
        projectTypes
        projectRankings {
          category
          ranking
        }
        experience
        experienceRankings {
          experience
          ranking
        }
        compentency {
          accessibility
          petFriendly
          smartHome
          customStorage
          specificAcoustic
          evironmentallySustainable
          uniqueLightingEffects
          historicalPreservation
          outdoorLiving
          specializedVentilation
          fengShui
          artIntegration
          wineCellar
          homeGym
          strengths {
            strength
            ranking
          }
        }
      }
      style {
        anyStyle
        knownForStyle
        strongStyles
        styleRankings {
          style
          ranking
        }
      }
      workStyle {
        partnershipOptions
        compensationModel
        presentationType
        minimumBudget
      }
      preferences {
        social {
          pronouns
          pets
          lgbtqPositive
          womenOwned
          minorityOwned
          politicalAffiliation
          otherPoliticalAffiliation
          preferSamePolitics
        }
        partnershipStyleRankings {
          partnershipStyle
          ranking
        }
        acquisitionPreferences
        acquisitionRankings {
          acquisitionPreference
          ranking
        }
        ageRange
        children
        zipCodes
      }
    }
  }
`;
